<script lang="ts">
// ConsentScript: Consent-gated wrapper that conditionally injects child content
// into svelte:head based on cookie consent for a specified category.
// Prevents tracking scripts from loading until explicit consent is granted.

import { cookieState } from "./cookieState.svelte";
import type { Snippet } from "svelte";

interface Props {
  category: string;
  children?: Snippet;
}

let { category, children }: Props = $props();

let hasConsent = $derived(
  cookieState[category as keyof typeof cookieState] || false,
);
</script>

{#if hasConsent && children}
  {@render children()}
{/if}
